export default class TrustindexDarkModeModule {
	constructor(widget)
	{
		this.widget = widget;
		this.isAutoDarkMode = !!this.widget.getAttribute('data-auto-dark-mode');
	}

	format()
	{
		if (this.isAutoDarkMode && Trustindex.isDarkMode() && !Trustindex.isAdminUrl()) {
			let cssUrl = Trustindex.getCDNUrl()+`assets/widget-presetted-css/${this.widget.layoutId}-dark-background.css`;
			if (this.widget.cssVersion) {
				cssUrl = cssUrl.replace('widget-presetted-css/', `widget-presetted-css/v${this.widget.cssVersion}/`);
			}

			(async () => {
				let style = document.createElement('style');
				style.innerHTML = await this.getCssContent(cssUrl);
				document.body.appendChild(style);

				this.changeLogosToDark(true);
			})();
		}

		this.changeLogosToDark();
	}

	async getCssContent(url)
	{
		let response = await fetch(url);
		if (!response.ok) {
			return null;
		}

		let cssString = await response.text();
		return this.extractColorsFromCss(cssString);
	}

	extractColorsFromCss(cssString)
	{
		cssString = cssString
			.replace('@charset "UTF-8";', '')
			.replace(/@font-face{[^}]+}/g, '')
			.replace(/@(?:media|key-frames) [^{]*{(.*?})}/gs, '')
			.trim();

		let widgetSelector = `[data-set-id="${this.widget.setId}"]`;
		if ('wp-widget' !== this.widget.pid) {
			widgetSelector += `[data-pid="${this.widget.pid}"]`;
		}

		let selectors = this.parseCss(cssString);
		let cssColorString = "";
		for (let selector in selectors) {
			cssColorString += selector.replace(/\[data-set-id='dark-background'\]/g, widgetSelector) + '{';

			for (let rule in selectors[selector]) {
				let value = selectors[selector][rule];
				if (-1 === value.indexOf('!important')) {
					value += '!important';
				}

				cssColorString += `${rule}:${value};`;
			}

			cssColorString += '}';
		}

		return cssColorString;
	}

	parseCss(content)
	{
		let selectors = {};
		let colorRegex = /^(#(?:[0-9a-fA-F]{3}){1,2}|rgba?\(\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}(\s*,\s*(0|1|0?\.\d+))?\))$/;

		content.matchAll(/([^{]+){(.*?)}/gs).forEach(match => {
			let rules = selectors[match[1]] || {};

			match[2].split(';').forEach(ruleTmp => {
				let rule = ruleTmp.split(':');
				let ruleKey = rule.shift();
				let ruleValue = rule.join(':');

				// skip non color rules
				if (-1 === ruleKey.indexOf('color') && -1 === ['box-shadow', 'text-shadow'].indexOf(ruleKey) && !colorRegex.test(ruleValue)) {
					return;
				}

				if (typeof rules[ruleKey] === 'undefined' || -1 !== ruleValue.indexOf('!important') || -1 === rules[ruleKey].indexOf('!important')) {
					rules[ruleKey] = ruleValue;
				}
			});

			if (Object.keys(rules).length) {
				selectors[match[1]] = rules;
			}
		});

		return selectors; // { selector: [ styles ] }
	}

	changeLogosToDark(forceDark = false)
	{
		let logos = this.widget.querySelectorAll('img[src*="/logo"][src$=".svg"]');
		logos.forEach(logo => {
			let src = logo.getAttribute('src').replace('-dark.svg', '.svg');

			if (forceDark || this.isLogoDark(logo)) {
				logo.setAttribute('src', src.replace('.svg', '-dark.svg'));
			} else {
				logo.setAttribute('src', src);
			}
		});
	}

	isLogoDark(logo)
	{
		if ('dark-' === this.widget.setId.substr(0, 5)) {
			return true;
		}

		let parent = logo.parentNode;
		let isLogoOutside = true;
		while (parent !== this.widget) {
			let computedStyle = window.getComputedStyle(parent, null);

			if (!/rgba\(\d+, \d+, \d+, 0\)/.test(computedStyle.backgroundColor)) {
				isLogoOutside = false;
				break;
			}

			parent = parent.parentNode;
		}

		if (isLogoOutside) {
			return false;
		}

		let otherDarkStyles = [
			'light-contrast',
			'light-contrast-large',
			'light-contrast-large-blue',
		];

		return -1 !== otherDarkStyles.indexOf(this.widget.setId);
	}
};